// extracted by mini-css-extract-plugin
module.exports = {"r-mobile":"SocialButton_r-mobile__CG3VA","r-not-mobile":"SocialButton_r-not-mobile__67H1_","container":"SocialButton_container__uF2Qs","icon":"SocialButton_icon__hf8uE"};